'use strict';

var React = require('react');

var SvgInventoryIcon = function SvgInventoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.265 2.952a2.25 2.25 0 0 0-2.53 0l-4.094 2.783a3.75 3.75 0 0 0-1.641 3.101v7.413a.75.75 0 0 0 1.5 0v-7.413c0-.745.369-1.441.985-1.86l4.093-2.784a.75.75 0 0 1 .844 0l4.093 2.784a2.25 2.25 0 0 1 .985 1.86v7.413a.75.75 0 0 0 1.5 0v-7.413a3.75 3.75 0 0 0-1.641-3.1l-4.094-2.784Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 16.968a1 1 0 0 1-.25.031h-3a1 1 0 0 1-1-1v-3.5a1 1 0 0 1 1-1h.75v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3h.75a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-.25-.031Zm.75-3.969v2.5h2v-2.5h-2Zm-1.5 2.5v-2.5h-2v2.5h2Zm1.75-4v-2.5h-2v2.5h2Z"
  }));
};
SvgInventoryIcon.displayName = "InventoryIcon";

exports.SvgInventoryIcon = SvgInventoryIcon;
